/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@xilo-mono/common/config';
import { Observable } from 'rxjs';
import { NotificationAlerts } from '../models';

export type CourierTemplateID =
  | 'account_activation'
  | 'account_creation_admin'
  | 'account_creation_agent_admin'
  | 'assigned_new_lead'
  | 'finished_form'
  | 'form_event'
  | 'new_lead'
  | 'share_form_url'
  | 'share_embed_script'
  | 'workflows_beta_opt_in'
  | 'client_portal_abandoned'
  | 'agent_notifications'
  | 'client_portal_events';

export interface CourierPayload {
  email: string; // TO : recipient
  template: CourierTemplateID;
  data: any;
}
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  oldApiUrl = `${this.configService.apiUrl}/lifecycle-email`;
  apiUrl = `${this.configService.apiUrl}/notifications`;
  note = null;
  courierUrl = `${this.configService.apiUrl}/courier`;

  constructor(private http: HttpClient, private configService: ConfigService) {}

  sendNotification(params: {
    clientId: number;
    formId: string;
    version: number;
    agentId?: number;
    attachPDF?: boolean;
    submissionId?: number;
    formEvent?: string;
  }) {
    return this.http.post(`${this.apiUrl}/send-emails`, params);
  }

  sendOldNotification(params: {
    clientId: any;
    formId: any;
    version: any;
    agentId?: any;
    attachPDF?: boolean;
    submissionId?: any;
  }) {
    const { clientId, formId, version, agentId, attachPDF, submissionId } =
      params;
    const ids = [
      { clientId },
      { formId },
      { version },
      { agentId },
      { attachPDF },
      { submissionId },
    ];
    let query = '';
    for (let i = 0; i < ids.length; i++) {
      const param = ids[i];
      const paramId = Object.keys(param)[0];
      if (param[paramId] !== null) {
        const operator = query.length === 0 ? '?' : '&';
        query += `${operator}${paramId}=${param[paramId]}`;
      }
    }
    return this.http.post(`${this.oldApiUrl}/v2-email${query}`, {});
  }

  sendAssginedAgentNotification(clientId) {
    return this.http.post(
      `${this.apiUrl}/send-assigned-agent-email/${clientId}`,
      {}
    );
  }

  sendCourierEmail(body: CourierPayload): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.courierUrl}/notification`,
      body
    );
  }

  // sendTrackerNotification : send emails to prospects on status of their submission
  sendTrackerNotification(
    notificationAlert: NotificationAlerts,
    submissionID: string | number
  ): Observable<any> {
    return this.http.post<Observable<any>>(
      `${this.configService.apiUrl}/new/client/tracker-notifications/submission/${submissionID}`,
      {
        notificationAlert,
      }
    );
  }
}
